
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kYLQ7", function(module, exports) {

$parcel$export(module.exports, "api", () => $06004b97fba8fb24$export$644d8ea042df96a6);
const $06004b97fba8fb24$var$API_URL = 'https://gamescon-backend-559ca0f1a07e.herokuapp.com/api';
const $06004b97fba8fb24$export$644d8ea042df96a6 = {
    /**
   * Realiza o login do usuário
   */ async login (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) // O Strapi geralmente manda o erro detalhado em result.error.message
        throw new Error(result.error?.message || 'Erro ao fazer login.');
        return result;
    },
    /**
   * Registra um novo usuário
   */ async register (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        /* if (!response.ok) {
      throw new Error(result.error?.message || 'Erro ao registrar usuário.');
    } */ return result;
    },
    /**
   * Gera um código de brinde para o usuário logado
   * @param jwt Token JWT recebido no login/registro
   */ async generateCode () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/generate`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // Aqui enviamos o token para o backend saber quem está pedindo o código
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) // Se ele já tiver um código, nós tratamos lá no backend pra retornar um erro ou a própria mensagem.
        // Dependendo de como você montou, pode ser que response.ok seja falso se der 400.
        throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    },
    /**
   * Pega todos os dados do usuário logado (incluindo o currentStage)
   * Ideal para chamar quando o jogo carrega!
   */ async getMe () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/users/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error('Erro ao carregar os dados do jogador.');
        return result; // Aqui virá { id: 1, username: "...", currentStage: 1, ... }
    },
    /**
   * Salva a fase atual do jogador
   */ async saveStage (stageNumber) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/save-progress`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                stage: stageNumber
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao salvar o jogo.');
        return result;
    },
    async getMyCodes () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error("Erro ao carregar o hist\xf3rico de c\xf3digos.");
        return result;
    },
    async sendNeozone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/neozones`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar neozone');
        return result;
    },
    async sendOpenzone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/ratings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar openzone');
        return result;
    },
    async sendFinal (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/rating-finals`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar final');
        return result;
    },
    async isActive () {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/actives/smhqnmg6356byro9113fq650`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    }
};

});


var $kYLQ7 = parcelRequire("kYLQ7");
async function $05f4ae63eb889043$var$initApp() {
    try {
        const response = await (0, $kYLQ7.api).isActive();
        if (response.data.active) {
            console.log("Experi\xeancia ativa. Redirecionando para a p\xe1gina principal...");
            window.location.href = './index.html';
            return;
        }
    } catch (error) {
        console.error("Erro ao verificar o status da experi\xeancia:", error);
    }
}
window.addEventListener("DOMContentLoaded", $05f4ae63eb889043$var$initApp);


//# sourceMappingURL=inactive.87381949.js.map
